import http from '../core/http-common'
import {
  ICampusServiceReservations,
  ISecResAccordionParams,
  ISecurityReservations,
  ISecurityReservationsRequest,
  ITrackingMultiUpdateResReq,
  ITrackingUpdateResReq,
} from '../types/TrackingType'
import { ISecurityLocations } from '../types/TrackingType'
import { IVisitedStatus, IVisitedStatusRequest } from '../types/TrackingType'

class TracingService {
  getGrantedSecurityLocations(isShared: boolean) {
    return http.get<ISecurityLocations[]>(`/Security/GetGrantedSecurityLocations?isShared=${isShared}`)
  }

  getSecurityReservations(request: ISecurityReservationsRequest) {
    return http.post<ISecurityReservations[]>('/Security/GetSecurityReservations', request)
  }

  updateVisitedStatus(request: IVisitedStatusRequest) {
    return http.post<IVisitedStatus>('/Security/UpdateVisitedStatus', request)
  }

  getSecurityResAccordion(request: ISecResAccordionParams) {
    return http.post('/Security/GetSecurityReservationsAccordion', request)
  }

  /* Campus Services Tracing */
  getCampusServiceReservations(request: ISecurityReservationsRequest) {
    return http.post<ICampusServiceReservations[]>('/CampusServiceReservation/GetReservationList', request)
  }

  updateReservationStatus(data: ITrackingUpdateResReq) {
    return http.post(`CampusServiceReservation/UpdateReservationStatus`, data)
  }

  updateMultiResCancel(data: ITrackingMultiUpdateResReq) {
    return http.post(`CampusServiceReservation/UpdateMultiReservationStatus`, data)
  }
}

export default new TracingService()
